/*
  Wrapware swap picker behavior (reboot phase 1b).
  Defined as a custom element so it works both on full product pages and
  inside AJAX-injected contexts like quick view, where inline scripts do
  not execute. Mirrors the theme's own variant-selects pattern.
  Markup is rendered by snippets/product-swap-picker.liquid.
*/
(function () {
  if (customElements.get('wrapware-swap-picker')) return;

  class WrapwareSwapPicker extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';

      this.sectionId = this.dataset.section;
      this.formId = this.dataset.productForm;

      var dataEl = this.querySelector('[data-swap-variants]');
      if (!dataEl) return;
      this.variants = JSON.parse(dataEl.textContent);

      this.barBundle = this.querySelector('.swap-picker--bar-bundle');
      this.barWrap = this.querySelector('.swap-picker--bar-wraponly');
      this.finishWrap = this.querySelector('.swap-picker--finish');
      this.finishName = this.querySelector('.swap-picker--finish-name');
      this.swatches = Array.prototype.slice.call(
        this.querySelectorAll('.swap-picker--swatch')
      );

      this.wrapOnly = null;
      this.bundles = [];
      var self = this;
      this.variants.forEach(function (v) {
        if (/wrap only/i.test(v.title)) self.wrapOnly = v;
        else if (/wrap\s*\+/i.test(v.title)) self.bundles.push(v);
      });
      if (!this.wrapOnly || this.bundles.length < 2) return;

      this.availableBundles = this.bundles.filter(function (b) { return b.available; });
      this.currentFinishTitle = (this.availableBundles[0] || this.bundles[0]).title;

      this.barBundle.addEventListener('click', function () {
        self.applyOptionValue(self.currentFinishTitle);
      });
      this.barWrap.addEventListener('click', function () {
        self.applyOptionValue(self.wrapOnly.title);
      });
      this.swatches.forEach(function (s) {
        s.addEventListener('click', function () {
          self.applyOptionValue(s.dataset.variantTitle);
        });
      });

      // Sync from the theme's variant-change event, plus a generic change
      // listener on the native (hidden) picker as a fallback. No timers.
      this.onVariantChange = function (e) {
        var id = e.detail && e.detail.variant && e.detail.variant.id
          ? e.detail.variant.id
          : self.currentVariantId();
        if (id) self.renderById(id);
      };
      document.addEventListener('product:variant-change', this.onVariantChange);

      var scope = document.getElementById('variant-selects-' + this.sectionId);
      if (scope) {
        scope.addEventListener('change', function () {
          requestAnimationFrame(function () {
            var id = self.currentVariantId();
            if (id) self.renderById(id);
          });
        });
      }

      // Initial state + bundle-first default. In injected contexts the
      // whole fragment exists at upgrade time; on full pages this element
      // upgrades after parse (deferred script), so the form input exists.
      var initial = this.currentVariantId();
      if (initial) this.renderById(initial);
      var urlHasVariant = /[?&]variant=/.test(window.location.search);
      if (!urlHasVariant && this.availableBundles.length) {
        var initialVariant = null;
        for (var i = 0; i < this.variants.length; i++) {
          if (String(this.variants[i].id) === String(initial)) {
            initialVariant = this.variants[i];
            break;
          }
        }
        if (initialVariant && /wrap only/i.test(initialVariant.title)) {
          this.applyOptionValue(this.availableBundles[0].title);
        }
      }
    }

    disconnectedCallback() {
      if (this.onVariantChange) {
        document.removeEventListener('product:variant-change', this.onVariantChange);
      }
    }

    currentVariantId() {
      var input = document.querySelector(
        '#' + this.formId + ' input[name="id"], input[name="id"][form="' + this.formId + '"]'
      );
      return input ? String(input.value) : null;
    }

    findByTitle(title) {
      for (var i = 0; i < this.variants.length; i++) {
        if (this.variants[i].title === title) return this.variants[i];
      }
      return null;
    }

    // Drive the theme's native (hidden) picker so its own JS updates
    // price, media, availability, URL, and the add-to-cart form.
    applyOptionValue(value) {
      var target = this.findByTitle(value);
      if (!target || !target.available) return;
      var scope = document.getElementById('variant-selects-' + this.sectionId);
      if (!scope) return;
      var radios = scope.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === value) {
          if (!radios[i].checked) {
            radios[i].checked = true;
            radios[i].dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }
      }
      var selects = scope.querySelectorAll('select');
      for (var j = 0; j < selects.length; j++) {
        for (var k = 0; k < selects[j].options.length; k++) {
          if (selects[j].options[k].value === value) {
            if (selects[j].value !== value) {
              selects[j].value = value;
              selects[j].dispatchEvent(new Event('change', { bubbles: true }));
            }
            return;
          }
        }
      }
    }

    shortFinish(title) {
      return title.replace(/^\s*Wrap\s*\+\s*/i, '').replace(/\s*Tumbler\s*$/i, '');
    }

    render(selectedTitle) {
      var isWrapOnly = /wrap only/i.test(selectedTitle);
      this.barBundle.classList.toggle('is-selected', !isWrapOnly);
      this.barWrap.classList.toggle('is-selected', isWrapOnly);
      this.finishWrap.classList.toggle('is-disabled', isWrapOnly);
      var self = this;
      this.swatches.forEach(function (s) {
        s.classList.toggle(
          'is-selected',
          !isWrapOnly && s.dataset.variantTitle === selectedTitle
        );
      });
      this.finishName.textContent = isWrapOnly
        ? 'Choosing a finish switches you to Wrap + Tumbler'
        : this.shortFinish(selectedTitle);
      if (!isWrapOnly) this.currentFinishTitle = selectedTitle;
    }

    renderById(id) {
      for (var i = 0; i < this.variants.length; i++) {
        if (String(this.variants[i].id) === String(id)) {
          this.render(this.variants[i].title);
          return;
        }
      }
    }
  }

  customElements.define('wrapware-swap-picker', WrapwareSwapPicker);
})();
